import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import {FormInlineRowComponent} from './../forms/form-inline-row';
import {MessageComponent, BaseComponent} from '../common/common-components';
import {DictionaryService} from "../services/dictionary-service";
import {MessageService} from "../services/message-service";
import { WalletService } from "./wallet-service";
import { UserService } from "../user/user-service";
import { BankAccountService } from "../accounts/bank-account-service";

let _ : any = require("lodash");

@Component({
    selector: 'dk-wallet-status',
    inputs: ['id'],
    template: require('./wallet-status.html'),
    entryComponents: [],
    providers: [DictionaryService, WalletService, BankAccountService, UserService]
})

export class WalletStatusComponent extends BaseComponent implements OnInit {
    id: any;
    currencyStates: any[];
    public isActive: boolean = true;
    public personalData: boolean = false;

    constructor(private walletService: WalletService, 
        private bankAccountService: BankAccountService,
        private userService: UserService) {
        super();
    }

    public ngOnInit() {
        this.bankAccountService.isAccountActive().subscribe(result => {
            if (result == false) {
                this.isActive = false;
            }
        });

        this.userService.accountInfo().subscribe(result => {
            this.personalData = result;
        });
        
        this.load();
    }

    load() {
        this.walletService.currencyState().subscribe(currencyStates => {
            this.currencyStates = currencyStates;
        });
    }

    refresh() {
        this.load();
    }
}
